import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { useCookies } from "react-cookie";
import BCLayout from "./components/BCLayout";
import BCProfile from "./components/BCProfile";
import BCProxy from "./components/BCProxy";
import BCError from "./components/BCError";
import BCDecline from "./components/BCDecline";
import Home from "./components/routes/Home";
import Pricing from "./components/routes/Pricing";
import Deals from "./components/routes/Deals";
import Activities from "./components/routes/Activities";
import LODeal from "./components/lo/LODeal";
import GetMyRate from "./components/routes/GetMyRate";
import BorrowerApplication from "./components/routes/BorrowerApplication";
import BPApplication from "./components/broker/BPApplication";
import Applications from "./components/routes/Applications";
import Loans from "./components/routes/Loans";
import { IErrorResponse, IPermission } from "./components/interfaces/Global";
import { MsalProvider, useIsAuthenticated, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import "semantic-ui-css/semantic.min.css";
import CacheBuster from "./CacheBuster";
import { BrokerConstants } from "./components/constants/BrokerConstants";
import { GlobalConstants, MsalConstants } from "./components/constants/GlobalConstants";
import BCBrokerage from "./components/BCBrokerage";
import BWVendorForm from "./components/borrower/BWVendorForm";
import BWMakeAPayment from "./components/borrower/BWMakeAPayment";
import BWPayoffQuoteRequestForm from "./components/borrower/BWPayoffQuoteRequestForm";
import BWWorkInspectionProject from "./components/borrower/BWWorkInspectionProject";
import BCStoresWrapper from "./components/BCStoresWrapper";
import HomePayments from "./components/routes/HomePayments";
import HomeBorrowerStatements from "./components/routes/HomeBorrowerStatements";
import HomeProjects from "./components/routes/HomeProjects";
import HomeDrawRequests from "./components/routes/HomeDrawRequests";
import { getEnvironmentDomain } from "./helpers/GlobalHelper";
import BCRedirect from "./components/BCRedirect";
import LmsLayout from "./components/lms/LmsLayout";
import LMSLoanApplications from "./components/lms/Loans/LmsLoanApplications";
import LmsLoanAssignments from "./components/lms/Loans/LmsLoanAssignments";
import LmsLoanDetails from "./components/lms/Loans/LmsLoanDetails";
import LmsLoanUploadBudget from "./components/lms/Loans/LmsLoanUploadBudget";
import BWCurrentWorkInspection from "./components/borrower/BWCurrentWorkInspection";
import LmsOrganizations from "./components/lms/Organizations/LmsOrganizations";
import LmsOrganizationsBorrowers from "./components/lms/Organizations/LmsOrganizationsBorrowers";
import LmsOrganizationsContacts from "./components/lms/Organizations/LmsOrganizationsContacts";
import LmsOrganizationsBorrowerOrgComments from "./components/lms/Organizations/LmsOrganizationsBorrower-Org Comments";
import LmsOrganizationsBankAccounts from "./components/lms/Organizations/LmsOrganizationsBankAccounts";
import SeeOurRates from "./components/routes/SeeOurRates";
import LmsDocuments from "./components/lms/Documents/LmsDocuments";
import LmsUploadDirectPayForm from "./components/lms/Documents/LmsUploadDirectPay";
import LmsUploadLoanDataCashFlow from "./components/lms/Documents/LmsUploadLoanDataCashFlow";
import LmsDocuSignStatus from "./components/lms/Documents/LmsDocuSignStatus";
import LmsDocuSignDocumentMaster from "./components/lms/Documents/LmsDocuSignDocumentMaster";
import LmsDocuSignSenderReceiver from "./components/lms/Documents/LmsDocuSignSenderReceiver";
import LmsVotingAssignFunds from "./components/lms/Voting/LmsVotingAssignFunds";
import LmsVotingLoanReview from "./components/lms/Voting/LmsVotingLoanReview";
import LmsVotingFundPolling from "./components/lms/Voting/LmsVotingFundPolling";
import LmsVotingRandomizer from "./components/lms/Voting/LmsVotingRandomizer";
import LmsVotingBTBP2Review from "./components/lms/Voting/LmsVotingBTBP2Review";
import BWLoanDrawDetails from "./components/borrower/home/BWLoanDrawDetails";
import BWLoanDrawDetailProcess from "./components/borrower/home/BWLoanDrawDetailProcess";
import LmsSystemsUsers from "./components/lms/Systems/LmsSystemsUsers";
import LmsExternalSystemsUsers from "./components/lms/Systems/LmsSystemsExternalUsers";
import LmsSystemsLockedLoans from "./components/lms/Systems/LmsSystemsLockedLoans";
import LmsSystemsLoanComments from "./components/lms/Systems/LmsSystemsLoanComments";
import LmsSystemsRelatedParties from "./components/lms/Systems/LmsSystemsRelatedParties";
import LmsNewMenusBorrowerApplicationEntity from "./components/lms/NewMenus/LmsNewMenusBorrowerApplicationEntity";
import LmsNewMenusCrossCollateral from "./components/lms/NewMenus/LmsNewMenusCrossCollateral";
import LmsNewMenusEmailBox from "./components/lms/NewMenus/LmsNewMenusEmailBox";
import LmsNewMenuLoanApplications from "./components/lms/NewMenus/LmsLoanApplications";
import LmsNewMenusCommentSubject from "./components/lms/NewMenus/LmsNewMenusCommentSubject";
import BPPricing2 from "./components/broker/BPPricing2";
import BrokerLayout from "./components/broker/BrokerLayout";
import LmsLoanBudgetTemplates from "./components/lms/Loans/LmsLoanBudgetTemplates";
import LmsOrganizationsMergeContacts from "./components/lms/Organizations/LmsOrganizationsMergeContacts";
import LmsFundsBankLoc from "./components/lms/Funds/LmsFundsBankLoc";
import LmsFundsBankLocHistory from "./components/lms/Funds/LmsFundsBankLocHistory";
import LmsFundsVotingMembers from "./components/lms/Funds/LmsFundsVotingMembers";
import LmsFundsFundAllocation from "./components/lms/Funds/LmsFundsFundAllocation";
import LmsFundsFundCapacity from "./components/lms/Funds/LmsFundsFundCapacity";
import LmsFundsFundCapacityCommitment from "./components/lms/Funds/LmsFundsFundCapacityCommitment";
import LmsFundsFundManagers from "./components/lms/Funds/LmsFundsFundManagers";
import LmsServicingDraws from "./components/lms/Servicing/LmsServicingDraws";
import LmsServicingAutoDraws from "./components/lms/Servicing/LmsServicingAutoDraws";
import DrawManagement from "./components/lms/Servicing/LmsServicingDrawManagement";
import LmsServicingBTBLoansForApproval from "./components/lms/Servicing/LmsServicingBTBLoansForApproval";
import LmsServicingRequestInspections from "./components/lms/Servicing/LmsServicingRequestInspections";
import LmsServicingPayoffQuotes from "./components/lms/Servicing/LmsServicingPayoffQuotes";
import LmsServicingRequestedInspections from "./components/lms/Servicing/LmsServicingRequestedInspections";
import LmsInsurance from "./components/lms/Servicing/LmsServicingInsurance";
import LmsServicingModifyBudgets from "./components/lms/Servicing/LmsServicingModifyBudgets";
import LmsServicingProperties from "./components/lms/Servicing/LmsServicingProperties";
import LmsServicingUnits from "./components/lms/Servicing/LmsServicingUnits";
import LmsServicingInspectionCompanyMessages from "./components/lms/Servicing/LmsServicingInspectionCompanyMessages";
import LmsServicingLoanHistory from "./components/lms/Servicing/LmsServicingLoanHistory";
import LmsServicingCloseAccountingMonth from "./components/lms/Servicing/LmsServicingCloseAccountingMonth";
import LmsServicingModifyBTBBudgets from "./components/lms/Servicing/LmsServicingModifyBTBBudgets";
import LmsServicingPurchaseAdviceQuote from "./components/lms/Servicing/LmsServicingPurchaseAdviceQuote";
import LmsServicingLoanSaleApprovals from "./components/lms/Servicing/LmsServicingLoanSaleApprovals";
import LmsServicingAmendments from "./components/lms/Servicing/LmsServicingAmendments";
import LmsLoanGmr from "./components/lms/Loans/LmsLoanGmr";
import { getFeatureFlags } from "./components/constants/LocalServerConstants";
import { getIsWhiteLabeled } from "./helpers/PermissionHelper";
import LmsVotingAmendmentReview from "./components/lms/Voting/LmsVotingAmendmentReview";
import LmsSalesTeamNationalSalesManager from "./components/lms/SalesTeam/LmsSalesTeamNationalSalesManager";
import LmsSalesTeamRegionalSalesManager from "./components/lms/SalesTeam/LmsSalesTeamRegionalSalesManager";
import LmsSalesTeamSeniorSalesExecutives from "./components/lms/SalesTeam/LmsSalesTeamSeniorSalesExecutives";
import LmsSalesTeamLoanOfficerSalesManager from "./components/lms/SalesTeam/LmsSalesTeamLoanOfficerSalesManager";
import LmsSalesTeamLoanOfficerPortfolioManager from "./components/lms/SalesTeam/LmsSalesTeamLoanOfficerPortfolioManager";
import LmsSalesTeamRegion from "./components/lms/SalesTeam/LmsSalesTeamRegion";
import LmsServicingPurchaseAdviceTransactions from "./components/lms/Servicing/LmsServicingPurchaseAdviceTransactions";
import LmsServicingPurchaseCompanyTransactions from "./components/lms/Servicing/LmsServicingPurchaseCompanyTransactions";
import LmsServicingPayoffTransactions from "./components/lms/Servicing/LmsServicingPayoffTransactions";
import LmsServicingLoanConditions from "./components/lms/Servicing/LmsServicingLoanConditions";
import LmsServicingCurrentInspections from "./components/lms/Servicing/LmsServicingCurrentInspections";
import LmsServicingAutoPoRestrictions from "./components/lms/Servicing/LmsServicingAutoPoRestrictions";
import LmsAccountingLoanTransactions from "./components/lms/Accounting/LmsAccountingLoanTranscations";
import LmsAccountingPostPayments from "./components/lms/Accounting/LmsAccountingPostPayments";
import LmsAccountingBankRoutings from "./components/lms/Accounting/LmsAccountingBankRoutings";
import LmsAccountingPurchasingCompanyPayments from "./components/lms/Accounting/LmsAccountingPurchasingCompanyPayments";
import LmsAccountingPurchasingCompanyInterest from "./components/lms/Accounting/LmsAccountingPurchasingCompanyInterest";
import LmsAccountingLateFeeTransactions from "./components/lms/Accounting/LmsAccountingLateFeeTransactions";
import LmsAccountingLoanDrawsAndTransactions from "./components/lms/Accounting/LmsAccountingLoanDrawsAndTransactions";
import LmsAccountingUnFundedDraws from "./components/lms/Accounting/LmsAccountingUnfundedDraws";
import LmsAccountingDrawsInProcess from "./components/lms/Accounting/LmsAccountingDrawsInProcess";
import LmsAccountingFundedDraws from "./components/lms/Accounting/LmsAccountingFundedDraws";
import LmsAccountingAccountingJe from "./components/lms/Accounting/LmsAccountingAccountingJe";
import LmsAccountingIRDetails from "./components/lms/Accounting/LmsAccountingIRDetails";
import LmsAccountingResidualAmountsQueue from "./components/lms/Accounting/LmsAccountingResidualAmountsQueue";
import LmsAccountingNetSuitJe from "./components/lms/Accounting/LmsAccountingNetSuitJe";
import LmsAccountingACHQueue from "./components/lms/Accounting/LmsAccountingACHQueue";
import LmsAccountingACHPaid from "./components/lms/Accounting/LmsAccountingACHPaid";
import LmsAccountingLoanPayments from "./components/lms/Accounting/LmsAccountingLoanPayments";
import LmsAccountingWeeklyRecalcReport from "./components/lms/Accounting/LmsAccountingWeeklyRecalcReport";
import LmsAccountingMonthlyRecalcReport from "./components/lms/Accounting/LmsAccountingMonthlyRecalcReport";
import LmsInspectionsInspectionCompanyDataMatch from "./components/lms/Inspections/LmsInspectionsInspectionCompanyDataMatch";
import LmsInspectionsSubmitToInspectionCompany from "./components/lms/Inspections/LmsInspectionsSubmitToInspectionCompany";
import LmsInspectionsInspectionCompanyPendingProjects from "./components/lms/Inspections/LmsInspectionsInspectionCompanyPendingProjects";
import LmsInspectionsInspectionCompanyProjectDocuments from "./components/lms/Inspections/LmsInspectionsInspectionCompanyProjectDocuments";
import LmsInspectionsInspectionCompanyProjects from "./components/lms/Inspections/LmsInspectionsInspectionCompanyProjects";
import LmsInspectionsInspectionCompanyDrawFunded from "./components/lms/Inspections/LmsInspectionsInspectionCompanyDrawFunded";
import LmsInspectionsInspectionCompanyInspectionDetails from "./components/lms/Inspections/LmsInspectionsInspectionCompanyInspectionDetails";
import LmsInspectionsInspectionCompanyMessageSubject from "./components/lms/Inspections/LmsInspectionsInspectionCompanyMessageSubject";
import LmsReports from "./components/lms/Reports/LmsReports";
import LmsReportsAbDataAtSale from "./components/lms/Reports/LmsReportsAbDataAtSale";
import LmsReportsBorrowerStatementCurrentInterestOwing from "./components/lms/Reports/LmsReportsBorrowerStatementCurrentInterestOwing";
import LmsReportsAbDataAfterSale from "./components/lms/Reports/LmsReportsAbDataAfterSale";
import LmsReportsWaterfallSummary from "./components/lms/Reports/LmsReportsWaterfallSummary";
import LmsReportsBorrowerStatementPreviousOwing from "./components/lms/Reports/LmsReportsBorrowerStatementPreviousOwing";
import LmsReportsWireAmounts from "./components/lms/Reports/LmsReportsWireAmounts";
import LmsReportsInspectionReady from "./components/lms/Reports/LmsReportsInspectionReady";
import LmsVendorsServiceAreas from "./components/lms/Vendors/LmsVendorsServiceAreas";
import LmsVendorsProductsServices from "./components/lms/Vendors/LmsVendorsProductsServices";
import LmsVendorsBudgetCategories from "./components/lms/Vendors/LmsVendorsBudgetCategories";
import LmsReportsCollections from "./components/lms/Reports/LmsReportsCollections";
import LmsVendorsBankAccounts from "./components/lms/Vendors/LmsVendorsBankAccounts";
import LmsVendorsMergeVendors from "./components/lms/Vendors/LmsVendorsMergeVendors";
import LmsInspectionsInspectionCompanyInspections from "./components/lms/Inspections/LmsInspectionsInspectionCompanyInspections";
import LmsNewMenusCreditRequest from "./components/lms/NewMenus/LmsNewMenusCreditRequest";
import LmsNewMenusLoanDocGeneration from "./components/lms/NewMenus/LmsNewMenusLoanDocGeneration";
import LmsNewMenusInvoice from "./components/lms/NewMenus/LmsNewMenusInvoice";
import LmsNewMenusConsoleReports from "./components/lms/NewMenus/LmsNewMenusConsoleReports";
import LmsNewMenusDocumentMasterRequirement from "./components/lms/NewMenus/LmsNewMenusDocumentMasterRequirement";
import LmsNewMenusEmailTemplates from "./components/lms/NewMenus/LmsNewMenusEmailTemplates";
import LmsNewMenusLoanDrawHistory from "./components/lms/NewMenus/LmsNewMenusLoanDrawHistory";
import LmsNewMenusGMRProjectCost from "./components/lms/NewMenus/LmsNewMenusGMRProjectCost";
import LmsNewMenusLoanDrawBatch from "./components/lms/NewMenus/LmsNewMenusLoanDrawBatch";
import LmsNewMenusEmailTag from "./components/lms/NewMenus/LmsNewMenusEmailTag";
import LmsNewMenusEmailMaster from "./components/lms/NewMenus/LmsNewMenusEmailMaster";
import LmsNewMenusLegalText from "./components/lms/NewMenus/LmsNewMenusLegalText";
import LmsNewMenusLoanSubStatusEmailConfig from "./components/lms/NewMenus/LmsNewMenusLoanSubStatusEmailConfig";
import LmsNewMenusValidationMessage from "./components/lms/NewMenus/LmsNewMenusValidationMessage";
import LmsNewMenusNotification from "./components/lms/NewMenus/LmsNewMenusNotification";
import LmsNewMenusLoanConditionDefault from "./components/lms/NewMenus/LmsNewMenusLoanConditionDefault";
import LmsNewMenusBorrowerVendor from "./components/lms/NewMenus/LmsNewMenusBorrowerVendor";
import LmsVotingCACMembers from "./components/lms/Voting/LmsVotingCACMembers";
import LmsInspectionsInspectionCompanyInspectionDocuments from "./components/lms/Inspections/LmsInspectionsInspectionCompanyInspectionDocuments";
import BCFeatureFlags from "./components/BCFeatureFlags";
import BCSubdomain from "./components/BCSubdomain";
import BWPaidAchPayments from "./components/borrower/BWPaidAchPayments";
import BWPendingApproval from "./components/borrower/BWPendingApproval";
import BWVendor from "./components/borrower/BWVendor";
import BWPayoffQuoteRequestAuto from "./components/borrower/BWPayoffQuoteRequestAuto";
import BWProjects from "./components/borrower/BWProjects";
import BWCurrentInspections from "./components/borrower/BWCurrentInspections";
import BWRequestedInspections from "./components/borrower/BWRequestedInspections";
import BWPastInspections from "./components/borrower/BWPastInspections";
import BWHome from "./components/borrower/BWHome";

const App = ({ pca }) => {
  const [cookies, setCookie, removeCookie] = useCookies([
    "session_portal",
    "session_menu",
    "session_submenu",
    "session_proxyuserid",
    "session_proxyusername",
    "session_proxyorganizationcontactid",
    "session_proxypermissions",
    "session_proxychannels",
    "session_proxyisexternal",
    "session_proxypreferredloanofficerorganizationcontactid",
    "msal_key1",
    "msal_key2",
    "msal_key3",
    "msal_key4",
    "msal_key5",
    "msal_key6",
    "msal_value1",
    "msal_value2",
    "msal_value3",
    "msal_value4",
    "msal_value5",
    "msal_value6",
    "msal_subdomain"
  ]);
  const isAuthenticated = useIsAuthenticated();
  const azureCancelErrorDescriptionCode = "AADB2C90091";
  if (!isAuthenticated && window.location.href.includes(azureCancelErrorDescriptionCode)) {
    window.location.href = window.location.origin;
  }

  useEffect(() => {
    const handleRedirectResponse = (response) => {
      if (getIsWhiteLabeled() && response && response.state && response.state !== "" &&
        localStorage.key(0) && localStorage.key(1) && localStorage.key(2) && localStorage.key(3) &&
        process.env.REACT_APP_ENV !== "LOCAL") {
        removeCookie("msal_subdomain");
        const sylDomain = getEnvironmentDomain();
        for (let i = 0; i < MsalConstants.SessionLength; i++) {
          setCookie(`msal_key${i + 1}` as any, localStorage.key(i), { domain: sylDomain });
          setCookie(`msal_value${i + 1}` as any, localStorage.getItem(localStorage.key(i) as string), { domain: sylDomain });
        }

        localStorage.clear();
        window.location.href = `https://${response.state}${getEnvironmentDomain()}/redirect`;
      }
    };

    pca.handleRedirectPromise().then(handleRedirectResponse);
  }, [pca]);

  return (
    <MsalProvider instance={pca}>
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

          return (
            <BCStoresWrapper>
              <Pages
                cookies={cookies}
                setCookie={setCookie}
                removeCookie={removeCookie}
              />
            </BCStoresWrapper>
          );
        }}
      </CacheBuster>
    </MsalProvider>
  );
};

export const AuthWrapper = ({ children }) => {
  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        {children}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Redirect to="/welcome" />
      </UnauthenticatedTemplate>
    </React.Fragment>
  );
};

const Pages = ({ cookies, setCookie, removeCookie }) => {
  const tabletSize = GlobalConstants.ScreenSizes.TABLET_SIZE;
  const mobileSize = GlobalConstants.ScreenSizes.MOBILE_SIZE;
  const timeoutLength = 150;
  const [isSidebar, setIsSidebar] = useState(false as boolean);
  const [isSidebarToggle, setIsSidebarToggle] = useState(true as boolean);
  const [isGreaterThanTablet, setIsGreaterThanTablet] = useState(window.innerWidth > tabletSize);
  const [isGreaterThanMobile, setIsGreaterThanMobile] = useState(window.innerWidth > mobileSize);
  const [isMessage, setIsMessage] = useState(false as boolean);
  const [errorResponse, setErrorResponse] = useState(undefined as IErrorResponse | undefined);
  const [successMessage, setSuccessMessage] = useState("" as string);
  const [isModalOpen, setIsModalOpen] = useState(false as boolean);
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(false as boolean);
  const [isW9MessageVisible, setIsW9MessageVisible] = useState(true as boolean);
  const [brokerColor, setBrokerColor] = useState(undefined as string | undefined);
  const [tenantLogo, setTenantLogo] = useState(undefined as any);
  const [isCreateNewUser, setIsCreateNewUser] = useState(false as boolean);
  const [newAvatarFile, setNewAvatarFile] = useState(undefined as any);
  const [subdomain, setSubdomain] = useState(undefined as string | undefined);

  const sessionTimeoutLength = 18000000; // 30 minutes
  interface GMRInfo {
    id: number;
    name: string;
    loanProgram: string;
    numberOfUnitsProperties: number;
    submittedOn: Date;
    isPropertySingle: boolean;
  }

  const [loanInfolist, setLoanInfolist] = useState([] as any[]);
  const [applicationInfolist, setApplicationInfolist] = useState([] as any[]);
  const [GMRInfoData, setGMRInfoData] = useState([] as GMRInfo[]);
  const [gmrEditData, setGmrEditData] = useState({} as any);
  const [copiedGmrId, setCopiedGmrId] = useState(undefined as string | undefined);
  const [copiedApplicationId, setCopiedApplicationId] = useState(undefined as string | undefined);
  const [user, setUser] = useState({} as any);
  const [permissions, setPermissions] = useState([] as IPermission[]);
  const [proxyUser, setProxyUser] = useState({} as any);
  const [isUserProfileEdit, setIsUserProfileEdit] = useState(false as boolean);
  const [isUserProfileUpdate, setIsUserProfileUpdate] = useState(false as boolean);
  const [isPricingStartScenarios, setIsPricingStartScenarios] = useState(false as boolean);
  const FeatureFlags = getFeatureFlags(user);
  const [dealData, setDealData] = useState(undefined as any);
  const getDealInfoById = (id) => {
    let dealInfo = undefined;
    if (dealData) {
      dealData.forEach(item => {
        const foundCard = item.cards.find(x => x.id === id);
        if (foundCard) {
          dealInfo = foundCard;
        }
      });
    }

    return dealInfo;
  };

  useEffect(() => {
    let timeoutId: any = null;
    let sessionTimeoutId: any = null;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsGreaterThanTablet(window.innerWidth > tabletSize);
        setIsGreaterThanMobile(window.innerWidth > mobileSize);
      }, timeoutLength);
    };

    const handleSessionTimeout = () => {
      clearTimeout(sessionTimeoutId);
      sessionTimeoutId = setTimeout(() => {
        removeCookie("session_portal");
      }, sessionTimeoutLength);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleSessionTimeout);
    window.addEventListener("mousemove", handleSessionTimeout);
    window.addEventListener("keydown", handleSessionTimeout);
    handleResize();
    handleSessionTimeout();
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleSessionTimeout);
      window.removeEventListener("mousemove", handleSessionTimeout);
      window.removeEventListener("keydown", handleSessionTimeout);
    };
  }, [removeCookie]);

  const layoutProps = {
    isGreaterThanTablet: isGreaterThanTablet,
    isGreaterThanMobile: isGreaterThanMobile,
    isSidebar: isSidebar,
    setIsSidebar: setIsSidebar,
    isSidebarToggle: isSidebarToggle,
    setIsSidebarToggle: setIsSidebarToggle,
    user: user,
    setUser: setUser,
    setProxyUser: setProxyUser,
    removeCookie: removeCookie,
    setIsMessage: setIsMessage,
    setErrorResponse: setErrorResponse,
    proxyUser: proxyUser,
    permissions: permissions,
    setPermissions: setPermissions,
    successMessage: successMessage,
    setSuccessMessage: setSuccessMessage,
    isModalOpen: isWelcomeModalOpen,
    setIsModalOpen: setIsWelcomeModalOpen,
    isW9MessageVisible,
    setIsW9MessageVisible,
    setBrokerColor,
    setTenantLogo,
    isCreateNewUser,
    setIsCreateNewUser,
    newAvatarFile,
    brokerColor: brokerColor,
    isUserProfileEdit,
    isUserProfileUpdate,
    copiedGmrId: copiedGmrId,
    setCopiedGmrId: setCopiedGmrId,
    setSubdomain: setSubdomain,
    subdomain,
    setCookie: setCookie
  };

  const brokerLayoutProps = {
    user: user,
    isSidebar: isSidebar,
    isGreaterThanTablet: isGreaterThanTablet,
    bcLayoutProps: layoutProps
  };

  const lmsLayoutProps = {
    user: user,
    isSidebar: isSidebar,
    isGreaterThanTablet: isGreaterThanTablet,
    bcLayoutProps: layoutProps
  };

  return (
    <Router>
      <Switch>
        <Route exact path="/subdomain">
          <BCSubdomain
            cookies={cookies}
            removeCookie={removeCookie}
          />
        </Route>
        <Route exact path="/redirect">
          <BCRedirect
            cookies={cookies}
            removeCookie={removeCookie}
          />
        </Route>
        <Route exact path="/welcome">
          <BCBrokerage
            isBrokerages={false}
            isMessage={isMessage}
            setIsMessage={setIsMessage}
            errorResponse={errorResponse}
            setErrorResponse={setErrorResponse}
            proxyUser={proxyUser}
            setCookie={setCookie}
            removeCookie={removeCookie}
          />
        </Route>
        <Route exact path="/featureflags">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <BCFeatureFlags user={user} setIsMessage={setIsMessage} setErrorResponse={setErrorResponse} />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route exact path="/brokerages">
          <AuthWrapper>
            <BCBrokerage
              isBrokerages={true}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
              setCookie={setCookie}
              removeCookie={removeCookie}
            />
          </AuthWrapper>
        </Route>
        <Route exact path="/see-our-rates">
          <SeeOurRates
            isGreaterThanMobile={isGreaterThanMobile}
            isGreaterThanTablet={isGreaterThanTablet}
            isSidebar={isSidebar}
            isMessage={isMessage}
            setIsMessage={setIsMessage}
            errorResponse={errorResponse}
            setErrorResponse={setErrorResponse}
            proxyUser={proxyUser}
            permissions={permissions}
            brokerColor={brokerColor}
            setGmrEditData={setGmrEditData}
            copiedGmrId={copiedGmrId}
            isPricingStartScenarios={isPricingStartScenarios}
            setIsPricingStartScenarios={setIsPricingStartScenarios}
            user={user}
          />
        </Route>
        {user.portal !== GlobalConstants.Portals.LMS && <Route exact path="/">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <Home
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                setSuccessMessage={setSuccessMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
                GMRInfoData={GMRInfoData}
                setGMRInfoData={setGMRInfoData}
                setGmrEditData={setGmrEditData}
                brokerColor={brokerColor}
                isW9MessageVisible={isW9MessageVisible}
                setIsW9MessageVisible={setIsW9MessageVisible}
                setCopiedGmrId={setCopiedGmrId}
                setCopiedApplicationId={setCopiedApplicationId}
                applicationInfolist={applicationInfolist}
                setApplicationInfolist={setApplicationInfolist}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>}
        <Route path={`/payeezy/success/${GlobalConstants.Payeezy.SUCCESS_ID}`} />
        <Route path={`/payeezy/failed/${GlobalConstants.Payeezy.FAILED_ID}`} />
        <Route path="/application/guarantor/decline">
          <BCDecline />
        </Route>
        <Route exact path="/pricing">
          <BrokerLayout {...brokerLayoutProps}>
            <Pricing
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              GMRInfoData={GMRInfoData}
              setGMRInfoData={setGMRInfoData}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              user={user}
              proxyUser={proxyUser}
              permissions={permissions}
              brokerColor={brokerColor}
              setCopiedGmrId={setCopiedGmrId}
              copiedApplicationId={copiedApplicationId}
              setIsPricingStartScenarios={setIsPricingStartScenarios}
            />
          </BrokerLayout>
        </Route>
        {FeatureFlags.IS_REDESIGN && <Route exact path="/pricing2">
          <BrokerLayout {...brokerLayoutProps}>
            <BPPricing2
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              GMRInfoData={GMRInfoData}
              setGMRInfoData={setGMRInfoData}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              user={user}
              proxyUser={proxyUser}
              permissions={permissions}
              brokerColor={brokerColor}
              setCopiedGmrId={setCopiedGmrId}
              copiedApplicationId={copiedApplicationId}
              setIsPricingStartScenarios={setIsPricingStartScenarios}
            />
          </BrokerLayout>
        </Route>}
        <Route path="/applications">
          <BrokerLayout {...brokerLayoutProps}>
            <Applications
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              applicationInfolist={applicationInfolist}
              setApplicationInfolist={setApplicationInfolist}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              user={user}
              proxyUser={proxyUser}
              permissions={permissions}
              brokerColor={brokerColor}
              setGmrEditData={setGmrEditData}
              setCopiedApplicationId={setCopiedApplicationId}
            />
          </BrokerLayout>
        </Route>
        <Route path="/loans">
          <BrokerLayout {...brokerLayoutProps}>
            <Loans
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              loanInfolist={loanInfolist}
              setLoanInfolist={setLoanInfolist}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              user={user}
              proxyUser={proxyUser}
              permissions={permissions}
              brokerColor={brokerColor}
              copiedApplicationId={copiedApplicationId}
              setCopiedApplicationId={setCopiedApplicationId}
            />
          </BrokerLayout>
        </Route>
        <Route path="/profile">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <BCProfile
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                setSuccessMessage={setSuccessMessage}
                user={user}
                proxyUser={proxyUser}
                handleProxyUser={setProxyUser}
                setUser={setUser}
                setIsW9MessageVisible={setIsW9MessageVisible}
                permissions={permissions}
                setIsCreateNewUser={setIsCreateNewUser}
                brokerColor={brokerColor}
                setTenantLogo={setTenantLogo}
                setNewAvatarFile={setNewAvatarFile}
                setIsUserProfileEdit={setIsUserProfileEdit}
                setIsUserProfileUpdate={setIsUserProfileUpdate}
                setSubdomain={setSubdomain}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route path="/proxy">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <BCProxy
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                handleProxyUser={setProxyUser}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route
          path="/getmyrate/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <GetMyRate
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
                gmrId={props.match.params.id}
                brokerColor={brokerColor}
                setGmrEditData={setGmrEditData}
                copiedGmrId={copiedGmrId}
                isPricingStartScenarios={isPricingStartScenarios}
                setIsPricingStartScenarios={setIsPricingStartScenarios}
              />
            </BrokerLayout>
          }
        />
        <Route
          path="/pricing/info/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <BPApplication
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                proxyUser={proxyUser}
                applicationId={props.match.params.id}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                user={user}
                permissions={permissions}
                setGmrEditData={setGmrEditData}
                brokerColor={brokerColor}
                setSuccessMessage={setSuccessMessage}
                isPricing={true}
                organizationContactId={(proxyUser && proxyUser.organizationContactId) ? proxyUser.organizationContactId : (user && user.organizationContactId) ? user.organizationContactId : null}
              />
            </BrokerLayout>
          }
        />
        <Route
          path="/application/borrower/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <BorrowerApplication
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                setSuccessMessage={setSuccessMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                gmrEditData={gmrEditData}
                setGmrEditData={setGmrEditData}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
                applicationId={props.match.params.id}
                copiedApplicationId={copiedApplicationId}
                brokerColor={brokerColor}
                tenantLogo={tenantLogo}
              />
            </BrokerLayout>
          }
        />
        {Object.values(BrokerConstants.InteriorCardTabs).map((interiorCardTab, i) => {
          if (!FeatureFlags.IS_GAME_CHANGERS && [BrokerConstants.InteriorCardTabs.Tasks.name, BrokerConstants.InteriorCardTabs.Milestones.name].indexOf(interiorCardTab.name) > -1) {
            return null;
          }

          return (
            <Route
              key={`interiorCardTab-${i}`}
              path={`/processing/${interiorCardTab.name.toLocaleLowerCase()}/:id`}
              render={(props) =>
                <BrokerLayout {...brokerLayoutProps}>
                  <BPApplication
                    isGreaterThanMobile={isGreaterThanMobile}
                    isGreaterThanTablet={isGreaterThanTablet}
                    isSidebar={isSidebar}
                    isMessage={isMessage}
                    setIsMessage={setIsMessage}
                    errorResponse={errorResponse}
                    setErrorResponse={setErrorResponse}
                    proxyUser={proxyUser}
                    applicationId={props.match.params.id}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    user={user}
                    permissions={permissions}
                    setGmrEditData={setGmrEditData}
                    brokerColor={brokerColor}
                    setSuccessMessage={setSuccessMessage}
                    isPricing={false}
                    organizationContactId={(proxyUser && proxyUser.organizationContactId) ? proxyUser.organizationContactId : (user && user.organizationContactId) ? user.organizationContactId : null}
                  />
                </BrokerLayout>
              }
            />
          );
        })}
        {Object.values(BrokerConstants.InteriorCardTabs).map((interiorCardTab, i) => {
          if (!FeatureFlags.IS_GAME_CHANGERS && [BrokerConstants.InteriorCardTabs.Tasks.name, BrokerConstants.InteriorCardTabs.Milestones.name].indexOf(interiorCardTab.name) > -1) {
            return null;
          }

          return (
            <Route
              key={`interiorCardTab-${i}`}
              path={`/application/${interiorCardTab.name.toLocaleLowerCase()}/:id`}
              render={(props) =>
                <BrokerLayout {...brokerLayoutProps}>
                  <BPApplication
                    isGreaterThanMobile={isGreaterThanMobile}
                    isGreaterThanTablet={isGreaterThanTablet}
                    isSidebar={isSidebar}
                    isMessage={isMessage}
                    setIsMessage={setIsMessage}
                    errorResponse={errorResponse}
                    setErrorResponse={setErrorResponse}
                    proxyUser={proxyUser}
                    applicationId={props.match.params.id}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    user={user}
                    permissions={permissions}
                    setGmrEditData={setGmrEditData}
                    brokerColor={brokerColor}
                    setSuccessMessage={setSuccessMessage}
                    isPricing={false}
                    organizationContactId={(proxyUser && proxyUser.organizationContactId) ? proxyUser.organizationContactId : (user && user.organizationContactId) ? user.organizationContactId : null}
                  />
                </BrokerLayout>
              }
            />
          );
        })}
        {/* {FeatureFlags.IS_GAME_CHANGERS && <Route path="/calendar">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <BPCalendar 
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>} */}
        <Route path="/deals">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <Deals
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                dealData={dealData}
                setDealData={setDealData}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                user={user}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route
          path="/deal/:id"
          render={(props) =>
            <AuthWrapper>
              <BCLayout {...layoutProps}>
                <LODeal
                  isGreaterThanMobile={isGreaterThanMobile}
                  isGreaterThanTablet={isGreaterThanTablet}
                  isSidebar={isSidebar}
                  isMessage={isMessage}
                  setIsMessage={setIsMessage}
                  errorResponse={errorResponse}
                  setErrorResponse={setErrorResponse}
                  deal={getDealInfoById(props.match.params.id)}
                  setDealData={setDealData}
                />
              </BCLayout>
            </AuthWrapper>
          }
        />
        <Route path="/activities">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <Activities
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                user={user}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        {user.portal === GlobalConstants.Portals.LMS && <Route exact path="/">
          <LmsLayout {...lmsLayoutProps}>
            <></>
          </LmsLayout>
        </Route>}
        <Route exact path="/loanapplications" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LMSLoanApplications params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanapplications/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LMSLoanApplications params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanapplications/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LMSLoanApplications params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loandetails" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanDetails params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loandetails/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanDetails params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loandetails/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanDetails params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanuploadbudget" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanUploadBudget params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanuploadbudget/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanUploadBudget params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanbudgettemplates" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanBudgetTemplates params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanbudgettemplates/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanBudgetTemplates params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanbudgettemplates/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanBudgetTemplates params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanassignments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanAssignments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loanassignments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanAssignments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/loangmr" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsLoanGmr />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-national-sales-manager" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamNationalSalesManager />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-regional-sales-manager" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamRegionalSalesManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-regional-sales-manager/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamRegionalSalesManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-regional-sales-manager/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamRegionalSalesManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-senior-sales-executives" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamSeniorSalesExecutives params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-senior-sales-executives/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamSeniorSalesExecutives params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-senior-sales-executives/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamSeniorSalesExecutives params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-loan-officer-sales-manager" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamLoanOfficerSalesManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-loan-officer-sales-manager/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamLoanOfficerSalesManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-loan-officer-sales-manager/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamLoanOfficerSalesManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-loan-officer-portfolio-manager" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamLoanOfficerPortfolioManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-loan-officer-portfolio-manager/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamLoanOfficerPortfolioManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-loan-officer-portfolio-manager/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamLoanOfficerPortfolioManager params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-region" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamRegion params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-region/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamRegion params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/sales-team-region/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSalesTeamRegion params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizations params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizations params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizations params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-borrowers" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBorrowers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-borrowers/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBorrowers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-borrowers/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBorrowers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-contacts" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsContacts routeType="mainPage" params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-merge-contacts" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsMergeContacts />
          </LmsLayout>
        } />
        <Route exact path="/organizations-contacts/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsContacts params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-contacts/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsContacts params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-borrower-org-comments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBorrowerOrgComments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-borrower-org-comments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBorrowerOrgComments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-bank-accounts" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBankAccounts params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-bank-accounts/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBankAccounts params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/organizations-bank-accounts/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsOrganizationsBankAccounts params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-draws" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingDraws params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-draws/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingDraws params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-draws/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingDraws params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-auto-draws" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAutoDraws params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-auto-draws/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAutoDraws params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-auto-draws/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAutoDraws params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-draw-management" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <DrawManagement />
          </LmsLayout>
        } />
        <Route exact path="/servicing-btb-loans-for-approval" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingBTBLoansForApproval params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-btb-loans-for-approval/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingBTBLoansForApproval params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-btb-loans-for-approval/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingBTBLoansForApproval params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-purchase-company-transactions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseCompanyTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-purchase-company-transactions/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseCompanyTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-purchase-advice-transactions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseAdviceTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-purchase-advice-transactions/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseAdviceTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-users" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsUsers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-users/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsUsers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-users/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsUsers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-external-users" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsExternalSystemsUsers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-external-users/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsExternalSystemsUsers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-external-users/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsExternalSystemsUsers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-locked-loans" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsLockedLoans />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-comments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsLoanComments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-comments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsLoanComments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-related-parties" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsRelatedParties params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-related-parties/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsSystemsRelatedParties params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-request-inspections" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingRequestInspections params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-requested-inspections" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingRequestedInspections params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-requested-inspections/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingRequestedInspections params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-requested-inspections/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingRequestedInspections params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-payoff-quotes" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPayoffQuotes params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-payoff-quotes/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPayoffQuotes params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-payoff-quotes/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPayoffQuotes params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-payoff-transactions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPayoffTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-payoff-transactions/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPayoffTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-insurance" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInsurance params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-insurance/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInsurance params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-insurance/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInsurance params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-modify-budgets" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingModifyBudgets params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-modify-budgets/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingModifyBudgets params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-modify-budgets/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingModifyBudgets params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-properties" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingProperties />
          </LmsLayout>
        } />
        <Route exact path="/servicing-units" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingUnits params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-units/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingUnits params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-units/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingUnits params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-inspection-company-messages" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingInspectionCompanyMessages params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-inspection-company-messages/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingInspectionCompanyMessages params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-inspection-company-messages/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingInspectionCompanyMessages params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-conditions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanConditions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-conditions/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanConditions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-conditions/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanConditions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-current-inspections" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingCurrentInspections params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-auto-po-restrictions" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAutoPoRestrictions />
          </LmsLayout>
        } />
        <Route exact path="/servicing-close-accounting-month" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingCloseAccountingMonth params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-close-accounting-month/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingCloseAccountingMonth params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-modify-btb-budgets" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingModifyBTBBudgets params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-modify-btb-budgets/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingModifyBTBBudgets params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-modify-btb-budgets/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingModifyBTBBudgets params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-purchase-advice-quote" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseAdviceQuote params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/servicing-purchase-advice-quote/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseAdviceQuote params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/servicing-purchase-advice-quote/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingPurchaseAdviceQuote params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/servicing-loan-sale-approvals" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanSaleApprovals params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-loan-sale-approvals/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanSaleApprovals params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-loan-sale-approvals/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanSaleApprovals params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-amendments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAmendments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-amendments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAmendments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/servicing-amendments/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingAmendments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/accounting-loan-transactions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanTransactions params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-loan-transactions/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanTransactions params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-loan-transactions/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanTransactions params={match.params} history={history}/>
            </LmsLayout>
        }/>
        <Route exact path="/accounting-post-payments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPostPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-post-payments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPostPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-post-payments/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPostPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-loan-payments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-loan-payments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-loan-payments/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-bank-routings" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingBankRoutings params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-bank-routings/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingBankRoutings params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-bank-routings/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingBankRoutings params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/accounting-purchasing-company-payments" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPurchasingCompanyPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-purchasing-company-payments/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPurchasingCompanyPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-purchasing-company-payments/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPurchasingCompanyPayments params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/accounting-purchasing-company-interest" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingPurchasingCompanyInterest params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-late-fee-transactions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLateFeeTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-late-fee-transactions/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLateFeeTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-loan-draws-and-transactions" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingLoanDrawsAndTransactions params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-unfunded-draws" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingUnFundedDraws />
          </LmsLayout>
        } />
        <Route exact path="/accounting-draws-in-process" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingDrawsInProcess />
          </LmsLayout>
        } />
        <Route exact path="/accounting-funded-draws" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingFundedDraws />
          </LmsLayout>
        } />
        <Route exact path="/accounting-accounting-je" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingAccountingJe params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-accounting-je/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingAccountingJe params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-accounting-je/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingAccountingJe params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-weekly-recalc-report" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingWeeklyRecalcReport params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-weekly-recalc-report/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingWeeklyRecalcReport params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-weekly-recalc-report/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingWeeklyRecalcReport params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-monthly-recalc-report" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingMonthlyRecalcReport params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-monthly-recalc-report/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingMonthlyRecalcReport params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-monthly-recalc-report/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingMonthlyRecalcReport params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-ir-details" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingIRDetails params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-ach-paid" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingACHPaid params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-ach-queue" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingACHQueue params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-net-suit-je" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingNetSuitJe params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/accounting-residual-amounts-queue" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingResidualAmountsQueue params={match.params} history={history} />
          </LmsLayout>
        } />
         <Route exact path="/accounting-residual-amounts-queue/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsAccountingResidualAmountsQueue params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuments params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-upload-direct-pay-form" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsUploadDirectPayForm params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-upload-direct-pay-form/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsUploadDirectPayForm params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-upload-loan-data-cash-flow" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsUploadLoanDataCashFlow params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-upload-loan-data-cash-flow/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsUploadLoanDataCashFlow params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-status" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignStatus params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-status/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignStatus params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-master" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignDocumentMaster params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-master/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignDocumentMaster params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-master/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignDocumentMaster params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-sender-receiver" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignSenderReceiver params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-sender-receiver/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignSenderReceiver params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/documents-docusign-sender-receiver/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsDocuSignSenderReceiver params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/inspection-company-data-match" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyDataMatch params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspection-company-pending-projects" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyPendingProjects params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-submit-to-inspection-company" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsSubmitToInspectionCompany params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-project-documents" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyProjectDocuments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-project-documents/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyProjectDocuments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-project-documents/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyProjectDocuments params={match.params} history={history} />
            </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspections" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspections params={match.params} history={history} />
            </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspections/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspections params={match.params} history={history} />
            </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspections/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspections params={match.params} history={history} />
            </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-projects" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyProjects params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-projects/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyProjects params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-projects/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyProjects params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-draw-funded" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyDrawFunded params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-draw-funded/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyDrawFunded params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-draw-funded/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyDrawFunded params={match.params} history={history} />
            </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspection-details" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspectionDetails params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspection-details/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspectionDetails params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspection-details/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspectionDetails params={match.params} history={history} />
            </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspection-documents" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspectionDocuments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspection-documents/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspectionDocuments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-inspection-documents/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyInspectionDocuments params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-message-subject" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyMessageSubject params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-message-subject/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyMessageSubject params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/inspections-inspection-company-message-subject/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsInspectionsInspectionCompanyMessageSubject params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-lms-reports" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReports params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/reports-lms-reports/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReports params={match.params} history={history}/>
          </LmsLayout>
        }/>  
        <Route exact path="/reports-lms-reports/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReports params={match.params} history={history}/>
          </LmsLayout>
        }/> 
        <Route exact path="/reports-borrower-statement-previous-owing" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsBorrowerStatementPreviousOwing params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-borrower-statement-current-interest-owing" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsBorrowerStatementCurrentInterestOwing params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-ab-data-at-sale" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsAbDataAtSale params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-ab-data-after-sale" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsAbDataAfterSale params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-waterfall-summary" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsWaterfallSummary params={match.params} history={history} />
          </LmsLayout>
        }/> 
        <Route exact path="/reports-wire-amounts" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsWireAmounts params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-collections" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsCollections  params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/reports-inspection-ready" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsReportsInspectionReady params={match.params} history={history} />
          </LmsLayout>
        }/>         
        <Route exact path="/vendors-budget-categories" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsBudgetCategories params={match.params} history={history} />
          </LmsLayout>
        }/>     
        <Route exact path="/vendors-products-services" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsProductsServices params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/vendors-products-services/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsProductsServices params={match.params} history={history} />
          </LmsLayout>
        }/>      
        <Route exact path="/vendors-bank-accounts" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsBankAccounts params={match.params} history={history} />
          </LmsLayout>
        }/>
        <Route exact path="/vendors-bank-accounts/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsBankAccounts params={match.params} history={history}/>
          </LmsLayout>
        }/>
        <Route exact path="/vendors-bank-accounts/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsBankAccounts params={match.params} history={history}/>
          </LmsLayout>
        }/>  
        <Route exact path="/vendors-merge-vendors" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsMergeVendors  params={match.params} history={history} />
          </LmsLayout>
        }/>   
        <Route exact path="/vendors-service-areas" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsServiceAreas params={match.params} history={history} />
          </LmsLayout>
        }/>   
        <Route exact path="/vendors-service-areas/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsServiceAreas params={match.params} history={history} />
          </LmsLayout>
        }/>   
        <Route exact path="/vendors-service-areas/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVendorsServiceAreas params={match.params} history={history} />
          </LmsLayout>
        }/>   
        <Route exact path="/voting-assign-fund" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingAssignFunds params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-assign-fund/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingAssignFunds params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-assign-fund/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingAssignFunds params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-loan-review" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingLoanReview params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-loan-review/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingLoanReview params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-loan-review/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingLoanReview params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-fund-polling" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingFundPolling params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-fund-polling/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingFundPolling params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-randomizer" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingRandomizer params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-randomizer/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingRandomizer params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-btb-p2-review" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingBTBP2Review params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-btb-p2-review/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingBTBP2Review params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-cac-members" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingCACMembers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-cac-members/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingCACMembers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-cac-members/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingCACMembers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-amendment-review" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingAmendmentReview params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-amendment-review/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsVotingAmendmentReview params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-history" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanHistory params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/servicing-loan-history/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsServicingLoanHistory params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-borrower-application-entity" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusBorrowerApplicationEntity params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-borrower-application-entity/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusBorrowerApplicationEntity params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-borrower-application-entity/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusBorrowerApplicationEntity params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-borrower-vendor" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusBorrowerVendor params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-borrower-vendor/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusBorrowerVendor params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-borrower-vendor/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusBorrowerVendor params={match.params} history={history} />
          </LmsLayout>
        } /> 
        <Route exact path="/new-menus-cross-collateral" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCrossCollateral params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-cross-collateral/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCrossCollateral params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-cross-collateral/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCrossCollateral params={match.params} history={history} />
          </LmsLayout>
        } />    
        <Route exact path="/new-menus-comment-subject" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCommentSubject params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-comment-subject/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCommentSubject params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-comment-subject/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCommentSubject params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-applications" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenuLoanApplications params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-applications/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenuLoanApplications params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-applications/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenuLoanApplications params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-credit-request" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCreditRequest params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-credit-request/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCreditRequest params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-credit-request/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusCreditRequest params={match.params} history={history} />
            </LmsLayout>
        } />    
        <Route exact path="/new-menus-console-reports" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusConsoleReports params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-document-master-requirement" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusDocumentMasterRequirement params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-templates" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailTemplates params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-templates/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailTemplates params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-templates/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailTemplates params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-draw-history" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanDrawHistory params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-box" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailBox params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-gmr-project-cost" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusGMRProjectCost params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-gmr-project-cost/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusGMRProjectCost params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-gmr-project-cost/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusGMRProjectCost params={match.params} history={history} />
          </LmsLayout>
        } />    
        <Route exact path="/new-menus-loan-doc-generation" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanDocGeneration params={match.params} history={history} />
            </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-draw-batch" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanDrawBatch params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-draw-batch/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanDrawBatch params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-draw-batch/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanDrawBatch params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-legal-text" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLegalText params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-legal-text/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLegalText params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-legal-text/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLegalText params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-sub-status-email-config" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanSubStatusEmailConfig params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-sub-status-email-config/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanSubStatusEmailConfig params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-sub-status-email-config/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanSubStatusEmailConfig params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-validation-message" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusValidationMessage params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-validation-message/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusValidationMessage params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-validation-message/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusValidationMessage params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-notification" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusNotification params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-notification/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusNotification params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-notification/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusNotification params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-invoice" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusInvoice params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-master" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailMaster params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-master/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailMaster params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-master/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailMaster params={match.params} history={history} />
          </LmsLayout>
        } />
         <Route exact path="/new-menus-loan-condition-default" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanConditionDefault params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-condition-default/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanConditionDefault params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-loan-condition-default/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusLoanConditionDefault params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-tag" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailTag params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-tag/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailTag params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/new-menus-email-tag/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsNewMenusEmailTag params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/bank-loc" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsBankLoc params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/bank-loc/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsBankLoc params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/bank-loc/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsBankLoc params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/bank-loc-history" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsBankLocHistory params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/bank-loc-history/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsBankLocHistory params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/bank-loc-history/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsBankLocHistory params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-members" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsVotingMembers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-members/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsVotingMembers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/voting-members/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsVotingMembers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/fund-allocation/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundAllocation params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/fund-allocation/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundAllocation params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/fund-allocation" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundAllocation params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/fund-capacity" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundCapacity />
          </LmsLayout>
        } />
        <Route exact path="/fund-capacity-commitment" render={() =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundCapacityCommitment />
          </LmsLayout>
        } />
        <Route exact path="/fund-managers" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundManagers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/fund-managers/:action" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundManagers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/fund-managers/:action/:id" render={({ match, history }) =>
          <LmsLayout {...lmsLayoutProps}>
            <LmsFundsFundManagers params={match.params} history={history} />
          </LmsLayout>
        } />
        <Route exact path="/home/drawrequests">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <HomeDrawRequests
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route exact path="/loandrawdetail/:id"
          render={(props) =>
            <AuthWrapper>
              <BCLayout {...layoutProps}>
                <BWLoanDrawDetails
                  isGreaterThanMobile={isGreaterThanMobile}
                  isGreaterThanTablet={isGreaterThanTablet}
                  isSidebar={isSidebar}
                  isMessage={isMessage}
                  setIsMessage={setIsMessage}
                  errorResponse={errorResponse}
                  setErrorResponse={setErrorResponse}
                  setSuccessMessage={setSuccessMessage}
                  proxyUser={proxyUser}
                  loanProps={props.location.state}
                />
              </BCLayout>
            </AuthWrapper>
          }
        />
        <Route exact path="/loandrawdetail/process/:id"
          render={(props) =>
            <AuthWrapper>
              <BCLayout {...layoutProps}>
                <BWLoanDrawDetailProcess
                  isGreaterThanMobile={isGreaterThanMobile}
                  isGreaterThanTablet={isGreaterThanTablet}
                  isSidebar={isSidebar}
                  brokerColor={brokerColor}
                  loanProps={props.location.state}
                />
              </BCLayout>
            </AuthWrapper>
          }
        />
        <Route exact path="/home/payments">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <HomePayments
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route exact path="/home/borrowerstatements">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <HomeBorrowerStatements
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route exact path="/home/loanproject">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <HomeProjects
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                user={user}
                proxyUser={proxyUser}
                permissions={permissions}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route exact path="/servicing">
          <BrokerLayout {...brokerLayoutProps}>
            <BWHome 
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              setSuccessMessage={setSuccessMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser= {proxyUser}
              setCopiedApplicationId={setCopiedApplicationId}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/paidachpayments">
          <BrokerLayout {...brokerLayoutProps}>
            <BWPaidAchPayments
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser= {proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/pendingapproval">
          <BrokerLayout {...brokerLayoutProps}>
            <BWPendingApproval
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/vendor">
          <BrokerLayout {...brokerLayoutProps}>
            <BWVendor
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route path="/vendor/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <BWVendorForm
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                setSuccessMessage={setSuccessMessage}
                proxyUser={proxyUser}
                vendorId={props.match.params.id}
              />
            </BrokerLayout>
          }
        />
        <Route exact path="/payoffquoterequestauto">
          <BrokerLayout {...brokerLayoutProps}>
            <BWPayoffQuoteRequestAuto
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route path="/payoffquoterequestauto/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <BWPayoffQuoteRequestForm
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                setSuccessMessage={setSuccessMessage}
                proxyUser={proxyUser}
                user={user}
                payoffQuoteRequestId={props.match.params.id}
              />
            </BrokerLayout>
          }
        />
        <Route exact path="/makeapayment">
          <BrokerLayout {...brokerLayoutProps}>
            <BWMakeAPayment
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/projects">
          <BrokerLayout {...brokerLayoutProps}>
            <BWProjects
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route path="/project/loan/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <BWWorkInspectionProject
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                proxyUser={proxyUser}
                user={user}
                projectId={props.match.params.id}
                projectProps={props.location.state}
              />
            </BrokerLayout>
          }
        />
        <Route exact path="/currentinspections">
          <BrokerLayout {...brokerLayoutProps}>
            <BWCurrentInspections
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
              setSuccessMessage={setSuccessMessage}
              user={user}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/currentinspections/loan/:id"
          render={(props) =>
            <BrokerLayout {...brokerLayoutProps}>
              <BWCurrentWorkInspection
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                isMessage={isMessage}
                setIsMessage={setIsMessage}
                errorResponse={errorResponse}
                setErrorResponse={setErrorResponse}
                proxyUser={proxyUser}
                user={user}
                projectId={props.match.params.id}
              />
            </BrokerLayout>
          }
        />
        <Route exact path="/requestedinspections">
          <BrokerLayout {...brokerLayoutProps}>
            <BWRequestedInspections
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/pastinspections">
          <BrokerLayout {...brokerLayoutProps}>
            <BWPastInspections
              isGreaterThanMobile={isGreaterThanMobile}
              isGreaterThanTablet={isGreaterThanTablet}
              isSidebar={isSidebar}
              isMessage={isMessage}
              setIsMessage={setIsMessage}
              errorResponse={errorResponse}
              setErrorResponse={setErrorResponse}
              proxyUser={proxyUser}
            />
          </BrokerLayout>
        </Route>
        <Route exact path="/error">
          <AuthWrapper>
            <BCLayout {...layoutProps}>
              <BCError
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
              />
            </BCLayout>
          </AuthWrapper>
        </Route>
        <Route render={() =>
          <Redirect to="/" />
        } />
      </Switch>
    </Router>
  );
};

export default App;